<template>
  <div class="dft-container" :style="container_Style">
    <div class="dft-list" :style="list_Style">
      <div :ref="'dftItem' + index" class="dft-item" v-for="(item, index) in tableData" :key="index"
        :style="list_item_Style(index)">
        <div class="dft-goods_img" :style="goods_img_Style">
          <el-image class="img_class" :style="image_Style" :src="item.smallImg" :fit="fit"></el-image>
        </div>
        <div class="dft-goods_description" :style="goods_description_Style">
          <div class="dft-goods_name" v-if="goodsName" :style="goods_name_Style(index)">{{ item.productName }}</div>
          <div class="dft-goods_info" v-if="show_goods_info" :style="goods_info_Style">{{ item.onlineSaleDesc }}</div>
          <div class="dft-press_area" :style="press_area_style">
            <div class="dft-goods_price" v-if="goodsPrice" :style="goods_price_Style(index)">

              <span class="normal">￥{{ item.onlineSalePrice }}</span>

              <span class="expensive">￥{{ item.onlineNormalPrice }}</span>
            </div>
            <div class="dft-goods_btn" v-if="goodsCart" :style="goods_btn_Style(index)">
              <i class="el-icon-shopping-cart-2 btn-icon"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    compData: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      showDialog: false,
      dftList: [],
      tableData: []
    };
  },
  watch: {
    compData: {
      handler: function (newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.getalllist()
            return
            switch (newVal[1]?.value) {
              case 0:
              case 2:
              case 3:
                this.dftList = [{
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/8cf0c263c498b0a6c8e7901681eddd57.jpeg!large.webp',
                  productName: '商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称',
                  productIntro: '商品描述---6',
                  sellPrice: '20',
                }, {
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/e90c4ea59d942625b60d22f936fbaf6d.jpg!large.webp',
                  productName: '商品名称---测试2',
                  productIntro: '商品描述---444发',
                  sellPrice: '20',
                }, {
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/afecab1e62f85478c3e672a048f677a2.jpeg!large.webp',
                  productName: '商品名称---测试9',
                  productIntro: '商品描述---effect',
                  sellPrice: '20',
                }]
                break;
              case 1:
              case 4:
                this.dftList = [{
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/8cf0c263c498b0a6c8e7901681eddd57.jpeg!large.webp',
                  productName: '商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称',
                  productIntro: '商品描述---6',
                  sellPrice: '20',
                }, {
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/e90c4ea59d942625b60d22f936fbaf6d.jpg!large.webp',
                  productName: '商品名称---测试2',
                  productIntro: '商品描述---444发',
                  sellPrice: '20',
                }, {
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/afecab1e62f85478c3e672a048f677a2.jpeg!large.webp',
                  productName: '商品名称---测试9',
                  productIntro: '商品描述---effect',
                  sellPrice: '220',
                }, {
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/e90c4ea59d942625b60d22f936fbaf6d.jpg!large.webp',
                  productName: '商品名称---测789999999999',
                  productIntro: '商品描述---撒旦发射点佛为',
                  sellPrice: '20',
                }]
                break;
              case 5:
                this.dftList = [{
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/8cf0c263c498b0a6c8e7901681eddd57.jpeg!large.webp',
                  productName: '商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称',
                  productIntro: '商品描述---6',
                  sellPrice: '20',
                }, {
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/e90c4ea59d942625b60d22f936fbaf6d.jpg!large.webp',
                  productName: '商品名称---测试2',
                  productIntro: '商品描述---444发',
                  sellPrice: '20',
                }, {
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/afecab1e62f85478c3e672a048f677a2.jpeg!large.webp',
                  productName: '商品名称---测试9',
                  productIntro: '商品描述---effect',
                  sellPrice: '220',
                }, {
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/e90c4ea59d942625b60d22f936fbaf6d.jpg!large.webp',
                  productName: '商品名称---测789999999999',
                  productIntro: '商品描述---撒旦发射点佛为',
                  sellPrice: '20',
                }, {
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/8cf0c263c498b0a6c8e7901681eddd57.jpeg!large.webp',
                  productName: '商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称',
                  productIntro: '商品描述---6',
                  sellPrice: '20',
                }, {
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/e90c4ea59d942625b60d22f936fbaf6d.jpg!large.webp',
                  productName: '商品名称---测试2',
                  productIntro: '商品描述---444发',
                  sellPrice: '20',
                }, {
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/afecab1e62f85478c3e672a048f677a2.jpeg!large.webp',
                  productName: '商品名称---测试9',
                  productIntro: '商品描述---effect',
                  sellPrice: '220',
                }]
                break;

              default:
                break;
            }
            // console.log('comp--D-ata==--??',newVal,this.dftList)
          });
        }
      },
      deep: true
    },
  },
  computed: {
    //数据
    goodsList() {
      console.log('goodsList==--??', this.compData)
      return this.compData[0]?.value.length > 0 ? this.compData[0]?.value : this.dftList
    },
    listClass() {
      return this.compData[1]?.value
    },
    goodsClass() {
      return this.compData[2]?.value
    },
    // 显示与否
    goodsName() {
      return this.compData[10]?.value == '1'
    },

    show_goods_info() {//是否显示商品描述
      return this.compData[11]?.value == '1'
    },
    goodsPrice() {
      return this.compData[12]?.value == '1'
    },
    goodsOldPrice() {
      return this.compData[13]?.value == '1'
    },
    goodsSaleNum() {
      return this.compData[14]?.value == '1'
    },
    goodsCart() {
      return this.compData[15]?.value != '3'
    },
    // 样式
    container_Style() {
      return {
        [this.compData[2]?.key]: this.compData[2]?.value,
        [this.compData[7]?.key]: this.compData[7]?.value,
        [this.compData[8]?.key]: this.compData[8]?.value == '1' ? '1px solid #e7e7e7' : 'none',
        'background-color': this.goodsClass == '1' || this.goodsClass == '3' ? '#ffffff' : 'transparent',
      }
    },
    list_Style() {//列表
      switch (this.listClass) {
        case 0:
          return {
            'flex-direction': 'column',
            'padding': `0 ${this.compData[8]?.value}px`,
            'margin-left': `-${this.compData[9]?.value / 2}px`,
            'margin-right': `-${this.compData[9]?.value / 2}px`,
            'padding-top': this.goodsClass == '1' ? '12px' : '0',
            'padding-bottom': this.goodsClass == '1' ? '12px' : '0',
            'background-color': this.goodsClass == '4' ? 'transparent' : '#ffffff',
          }
        case 1:
          return this.goodsClass == 5 ? {
            'display': 'grid',
            'grid-auto-rows': '5px',
            'grid-template-columns': 'repeat(auto-fill, calc(50% - 0))',
            'align-items': 'start',
            'justify-content': 'space-between',
            'padding': `0 ${this.compData[8]?.value}px`,
            'margin-left': `-${this.compData[9]?.value / 2}px`,
            'margin-right': `-${this.compData[9]?.value / 2}px`,
            'background-color': this.goodsClass == '4' ? 'transparent' : '#ffffff',
          } : {
            'display': 'grid',
            'grid-template-columns': 'repeat(2, 1fr)',
            'padding': `0 ${this.compData[8]?.value}px`,
            'margin-left': `-${this.compData[9]?.value / 2}px`,
            'margin-right': `-${this.compData[9]?.value / 2}px`,
            'background-color': this.goodsClass == '4' ? 'transparent' : '#ffffff',
          }
        case 2:
          return {
            'flex-wrap': 'wrap',
            'padding': `0 ${this.compData[8]?.value}px`,
            'margin-left': `-${this.compData[9]?.value / 2}px`,
            'margin-right': `-${this.compData[9]?.value / 2}px`,
            'background-color': this.goodsClass == '4' ? 'transparent' : '#ffffff',
          }
        case 3:
          return {
            'flex-direction': 'column',
            'padding': `0 ${this.compData[8]?.value}px`,
            'margin-left': `-${this.compData[9]?.value / 2}px`,
            'margin-right': `-${this.compData[9]?.value / 2}px`,
            'background-color': this.goodsClass == '4' ? 'transparent' : '#ffffff',
          }
        case 4:
          return {
            'flex-wrap': 'nowrap',
            'overflow-x': 'auto',
            'padding': `0 ${this.compData[8]?.value}px`,
            'margin-left': `-${this.compData[9]?.value / 2}px`,
            'margin-right': `-${this.compData[9]?.value / 2}px`,
            'background-color': this.goodsClass == '4' ? 'transparent' : '#ffffff',
          }
        case 5:
          return {
            'display': 'grid',
            'grid-template-columns': 'repeat(2, 1fr)',
            'padding': `0 ${this.compData[8]?.value}px`,
            'margin-left': `-${this.compData[9]?.value / 2}px`,
            'margin-right': `-${this.compData[9]?.value / 2}px`,
            'background-color': this.goodsClass == '4' ? 'transparent' : '#ffffff',
          }
        default:
          return {
          }
      }
    },
    list_item_Style() {//每一项
      return index => {
        switch (this.listClass) {
          case 0:
            return {
              // 'width': '100%',
              'display': 'flex',
              'background-color': '#ffffff',
              'margin': `${this.compData[9]?.value / 2}px`,
              'box-shadow': this.goodsClass == '2' ? '0 2px 12px rgba(100, 101, 102, .12)' : 'unset',
              'border': this.goodsClass == '3' ? '1px solid #ebedf0' : 'none',
            }
          case 1:
            return this.goodsClass == 5 ? this.getLitemStyle(index) : {
              'margin': `${this.compData[9]?.value / 2}px`,
              'box-shadow': this.goodsClass == '2' ? '0 2px 12px rgba(100, 101, 102, .12)' : 'unset',
              'border': this.goodsClass == '3' ? '1px solid #ebedf0' : 'none',
            }
          case 2:
            return {
              'width': `calc((100% / 3) - ${this.compData[9]?.value}px)`,
              'margin': `${this.compData[9]?.value / 2}px`,
              'box-shadow': this.goodsClass == '2' ? '0 2px 12px rgba(100, 101, 102, .12)' : 'unset',
              'border': this.goodsClass == '3' ? '1px solid #ebedf0' : 'none',
            }
          case 3:
            return {
              'width': `calc(100% - ${this.compData[9]?.value}px)`,
              'margin': `${this.compData[9]?.value / 2}px`,
              'box-shadow': this.goodsClass == '2' ? '0 2px 12px rgba(100, 101, 102, .12)' : 'unset',
              'border': this.goodsClass == '3' ? '1px solid #ebedf0' : 'none',
            }
          case 4:
            return {
              'width': `calc(30% - ${this.compData[9]?.value}px)`,
              'flex-shrink': '0',
              'margin': `${this.compData[9]?.value / 2}px`,
              'box-shadow': this.goodsClass == '2' ? '0 2px 12px rgba(100, 101, 102, .12)' : 'unset',
              'border': this.goodsClass == '3' ? '1px solid #ebedf0' : 'none',
            }
          case 5:
            return index % 3 == 0 ? {
              'grid-column': '1 / 3',
              'margin': `${this.compData[9]?.value / 2}px`,
              'box-shadow': this.goodsClass == '2' ? '0 2px 12px rgba(100, 101, 102, .12)' : 'unset',
              'border': this.goodsClass == '3' ? '1px solid #ebedf0' : 'none',
            } : {}
          default:
            return {
            }
        }
      }

    },
    //--商品图
    goods_img_Style() {
      switch (this.listClass) {
        case 0:
          return {
            'width': '138px',
            'height': '138px',
            'margin': this.goodsClass == '2' ? '8px 0 8px 8px' : '0',
            'margin-right': '8px',
            'flex-shrink': '0',
            [this.compData[3]?.key]: this.compData[3]?.value,
          }
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          return {
            'width': '100%',
            [this.compData[3]?.key]: this.compData[3]?.value,
            [this.compData[4]?.key]: this.compData[4]?.value,
          }
        default:
          return {
          }
      }
    },
    image_Style() {
      return {
      }
    },
    fit() {
      return this.compData[5]?.value
    },

    goods_description_Style() {//商品信息
      switch (this.listClass) {
        case 0:
          return {
            'flex': '1',
            'padding': this.goodsClass == '2' || this.goodsClass == '3' ? '8px 8px 8px 0' : '0',
          }
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          return {
            'padding': '0 8px 10px',
          }
        default:
          return {
          }
      }
    },
    goods_name_Style() {//商品名
      return index => {
        switch (this.listClass) {
          case 0:
            return {
              'max-height': '20px',
              '-webkit-line-clamp': '1',
              [this.compData[6]?.key]: this.compData[6]?.value,
              [this.compData[7]?.key]: this.compData[7]?.value,
            }
          case 1:
          case 2:
          case 4:
            return {
              'font-size': '12px',
              'margin-top': '8px',
              'max-height': '20px',
              '-webkit-line-clamp': '1',
              [this.compData[6]?.key]: this.compData[6]?.value,
              [this.compData[7]?.key]: this.compData[7]?.value,
            }
          case 3:
            return {
              'margin-top': '8px',
              'max-height': '20px',
              '-webkit-line-clamp': '1',
              [this.compData[6]?.key]: this.compData[6]?.value,
              [this.compData[7]?.key]: this.compData[7]?.value,
            }
          case 5:
            return index % 3 == 0 ? {
              'margin-top': '8px',
              'max-height': '20px',
              '-webkit-line-clamp': '1',
              [this.compData[6]?.key]: this.compData[6]?.value,
              [this.compData[7]?.key]: this.compData[7]?.value,
            } : {
              'font-size': '12px',
              'margin-top': '8px',
              'max-height': '20px',
              '-webkit-line-clamp': '1',
              [this.compData[6]?.key]: this.compData[6]?.value,
              [this.compData[7]?.key]: this.compData[7]?.value,
            }
          default:
            return {
            }
        }
      }
    },
    goods_info_Style() {//商品描述
      return {
      }
    },
    press_area_style() {//商品价格区域
      switch (this.listClass) {
        case 0:
        case 3:
          return {
            'padding-top': '12px',
          }
        case 1:
        case 2:
        case 4:
          return {
            'padding-top': '0',
          }
        default:
          return {
          }
      }
    },
    goods_price_Style() {//商品价格
      return index => {
        switch (this.listClass) {
          case 0:
          case 1:
          case 3:
            return {
              'font-size': '18px',
              'line-height': '18px',
              [this.compData[6]?.key]: this.compData[6]?.value,
              [this.compData[7]?.key]: this.compData[7]?.value,
            }
          case 2:
          case 4:
            return {
              'font-size': '16px',
              'line-height': '16px',
              [this.compData[6]?.key]: this.compData[6]?.value,
              [this.compData[7]?.key]: this.compData[7]?.value,
            }
          case 5:
            return index % 3 == 0 ? {
              'font-size': '18px',
              'line-height': '18px',
              [this.compData[6]?.key]: this.compData[6]?.value,
              [this.compData[7]?.key]: this.compData[7]?.value,
            } : {
              'font-size': '16px',
              'line-height': '16px',
              [this.compData[6]?.key]: this.compData[6]?.value,
              [this.compData[7]?.key]: this.compData[7]?.value,
            }
          default:
            return {
            }
        }
      }
    },
    goods_btn_Style() {//商品按钮
      return index => {
        switch (this.listClass) {
          case 0:
          case 1:
          case 3:
            return {
              'font-size': '24px',
              'line-height': '20px',
            }
          case 2:
          case 4:
            return {
              'font-size': '18px',
              'line-height': '18px',
            }
          case 5:
            return index % 3 == 0 ? {
              'font-size': '24px',
              'line-height': '20px',
            } : {
              'font-size': '18px',
              'line-height': '18px',
            }
          default:
            return {
            }
        }
      }
    },
  },
  created() {
  },

  mounted() {
    this.$nextTick(() => {
    })
  },

  methods: {
    initData() {
    },
    getalllist() {
      this.tableData = []
      console.log('this.goodsList', this.goodsList)
      if (this.goodsList?.length > 0) {
        this.goodsList.forEach(async (item) => {
          await this.getproduct(item)
        })
      }
    },
    // 回显数据
    async getproduct(ditem) {
      console.log('getproduct', ditem)
      var that = this;
      const _data = {
        condition: {
          productCode: ditem.productCode,
          productStatus: 1,
          merchantCode: localStorage.getItem('merchantCode'),
        },
        currPage: 1,
        pageSize: 10
      }
      await that.$http.post("/merchantProduct/list", _data).then(function (response) {
        if (response.data.code == 200 && response.data?.data?.data?.length > 0) {
          that.tableData = that.tableData.concat(response.data.data?.data || [])
        }
        console.log('that.tableData', that.tableData)
      }).catch(err => { })
    },
    getLitemStyle(index) {
      this.$nextTick(() => {
        const el = this.$refs['dftItem' + index][0]
        const rows = Math.ceil(el.clientHeight / 5) + 0
        console.log('>J?', index, el, rows)
        el.style.gridRowEnd = `span ${rows}`
        el.style.margin = `${this.compData[9]?.value / 2}px`
        // el.style = {'grid-row-end': `span ${rows}`}
        // return {'grid-row-end': 'span ' + rows}
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.dft-container {
  width: 100%;
  box-sizing: border-box;
}

.dft-list {
  display: flex;

  .dft-item {
    box-sizing: border-box;

    .dft-goods_img {
      position: relative;
      max-height: 500px;
      overflow: hidden;
    }

    .dft-goods_description {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .dft-goods_name {
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        line-height: 20px;
        font-size: 14px;
      }

      .dft-goods_info {
        flex: 1;
        color: #969799;
        font-size: 12px;
        line-height: 16px;
        word-break: break-all;
        margin-top: 4px;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }

      .dft-press_area {
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        margin: 0;

        .dft-goods_price {
          flex: 1;
          height: 18px;
          color: #f44;
          word-break: break-all;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          display: flex;
          align-items: flex-end;

          .normal {
            font-size: 16px;
            color: #d9001b;
            font-weight: 600;
          }

          .expensive {
            margin-left: 5px;
            text-decoration: line-through;
            color: #aaa;
            font-size: 12px;
          }

          .price-tag {
            margin-right: 2px;
            font-size: 12px;
            line-height: 14px;
          }

          .price-sale-price {
            font-family: Avenir;
          }
        }

        .dft-goods_btn {
          flex-shrink: 0;
          font-size: 14px;

          .btn-icon {
            padding: 4px;
            color: #75E07F;
            border: 1px solid #75E07F;
            border-radius: 50%;
          }
        }
      }
    }
  }
}

.img_class {
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
</style>